import type { RefObject } from "react";
import { useLayoutEffect, useState } from "react";

/** Matches the box `ResizeObserver`'s `contentRect` reports. */
function contentWidth(element: HTMLElement): number {
    const { paddingLeft, paddingRight } = getComputedStyle(element);
    return (
        element.clientWidth -
        (parseFloat(paddingLeft) || 0) -
        (parseFloat(paddingRight) || 0)
    );
}

/** The element's current content width in px, 0 before the first layout. */
export function useElementWidth(ref: RefObject<HTMLElement | null>): number {
    const [width, setWidth] = useState(0);
    useLayoutEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        setWidth(contentWidth(element));
        const observer = new ResizeObserver(([entry]) => {
            if (entry) {
                setWidth(entry.contentRect.width);
            }
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref]);
    return width;
}
